/**
 * Лінивий чанк діалогу швидкого створення (DAT-01) — окремо від стану в `quick-create.ts`: той
 * бере `sign-out.ts`, а діалог через `meta.ts` веде до `sign-out.ts`, тож ребро `import()` звідти
 * замкнуло б цикл (`no-circular`). Беруть лише оболонка (`QuickCreateHost.tsx`) і попереднє
 * завантаження (`app/preload.ts`).
 */
export const loadQuickCreate = () => import('./create/QuickCreateDialog.tsx');

/** Попереднє завантаження діалогу в простої: ним користуються весь день (DAT-01, «Продуктивність»). */
export const prefetchQuickCreate = (): Promise<unknown> => loadQuickCreate().catch(() => undefined);
